import { requestAuthentication } from '../../../shared/actions/user';
import { TThunkDispatch } from '../../../shared/types/redux';

/**
 * Старые компоненты открывают авторизацию через window.waitForLoginPopup, который раньше определяла шапка.
 * Шапка-микрофронтенд его не предоставляет, поэтому окно открывается через её API
 */
export function installWaitForLoginPopup(dispatch: TThunkDispatch): void {
  window.waitForLoginPopup = () => {
    dispatch(requestAuthentication({ autoRefresh: true }));
  };
}
